import React, { useCallback, useEffect, useState } from 'react'
import { Col } from 'antd'
import Car from './Car'
import useMyGarageApi from '../../../../config/hooks/api/mygarage/useMyGarageApi'
import { useDispatch } from 'react-redux'
import { setAppLoading } from '../../../../store/common/generalSlice'


const CarList = ({ refreshFeed, refreshFeedHandler }) => {
  const dispatch = useDispatch()

  const { getVehicles } = useMyGarageApi()

  const [vehicles, setVehicles] = useState([])

  const getVehicleList = useCallback(async () => {
    try {
      dispatch(setAppLoading(true))

      const response = await getVehicles()
      if (response) {
        setVehicles(response?.data?.vehicles)
        dispatch(setAppLoading(false))
      }

    } catch (error) {
      console.log(error)
      dispatch(setAppLoading(false))
    }
  }, [])

  // Fetch vehicle list on component mount
  useEffect(() => {
    getVehicleList();
  }, [getVehicleList]);

  // Run getVehicleList whenever refreshFeed changes
  useEffect(() => {
    if (refreshFeed) {
      getVehicleList();
    }
  }, [refreshFeed, getVehicleList]);
  
  
  return (
    <React.Fragment>
      {vehicles && vehicles.length ? vehicles.map(vehicle => (
        <Col lg={8} md={12} sm={24} xs={24} key={vehicle?.id}>
          <Car data={vehicle} refreshFeed={refreshFeed} refreshFeedHandler={refreshFeedHandler} />
        </Col>
      )) : ''}
    </React.Fragment>
  )
}

export default CarList